import type { ComponentPropsWithRef, ReactNode } from "react";

import { cn } from "../lib/cn";

export interface EmptyStateProps extends Omit<ComponentPropsWithRef<"div">, "title"> {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** Action de sortie. Un état vide sans porte de sortie est une impasse. */
  action?: ReactNode;
}

/**
 * État vide : liste sans résultat, filtre trop restrictif, section pas encore
 * remplie. Toujours proposer l'action qui permet d'en sortir.
 */
export function EmptyState({
  className,
  icon,
  title,
  description,
  action,
  ...props
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex animate-fade-in flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-border px-6 py-12 text-center",
        className,
      )}
      {...props}
    >
      {icon && (
        <span
          className="flex size-10 items-center justify-center rounded-full bg-surface-sunken text-fg-subtle [&_svg]:size-5"
          aria-hidden="true"
        >
          {icon}
        </span>
      )}
      <div className="flex flex-col gap-1">
        <p className="font-medium text-fg">{title}</p>
        {description && <p className="max-w-sm text-sm text-fg-muted">{description}</p>}
      </div>
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
